import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import viewState from 'focus_groups/ducks/view_state';
import voteReducer from 'focus_groups/ducks/vote';
import results from 'focus_groups/ducks/results';
import entriesReducer from 'focus_groups/ducks/entries';

const RootReducer = combineReducers({
  details: formReducer,
  participants: formReducer,
  settings: formReducer,
  vote: voteReducer,
  entries: entriesReducer,
  viewState,
  results,
});

export default RootReducer;
